import { Civility } from './enums/civility.enum';
import { User } from './user.model';

export interface IRegisteredAddress {
  id?: number;
  fullname?: string;
  streetNumber?: string;
  street?: string;
  zipCode?: string;
  department?: string;
  city?: string;
  cityCode?: string;
  country?: string;
  additionals?: string;
  contactCivility?: Civility;
  contactFirstName?: string;
  contactLastName?: string;
  contactMail?: string;
  contactPhone?: string;
  loadingConstraint?: string;
  accessConstraint?: string;
  alias?: string;
  pickupUser?: User;
  deliveryUser?: User;
}

export class RegisteredAddress implements IRegisteredAddress {
  constructor(
    public id?: number,
    public fullname?: string,
    public streetNumber?: string,
    public street?: string,
    public zipCode?: string,
    public department?: string,
    public city?: string,
    public cityCode?: string,
    public country?: string,
    public additionals?: string,
    public contactCivility?: Civility,
    public contactFirstName?: string,
    public contactLastName?: string,
    public contactMail?: string,
    public contactPhone?: string,
    public loadingConstraint?: string,
    public accessConstraint?: string,
    public alias?: string,
    public pickupUser?: User,
    public deliveryUser?: User
  ) {}
}
